/*-----------------------------------------------------------------------------------
 * Kingsoft Office Enterprise Cloud Services.
 * Copyright (c) Kingsoft Office,All rights reserved.
 *-----------------------------------------------------------------------------------*/

/**
 * @desc 加密
 * @param key {string} 密钥
 * @param text {string} 加密的数据
 * */
export const encryptTextWithToken = (key, text) => {
  let encryptedText = ''
  for (let i = 0; i < text.length; i++) {
    let charCode = text.charCodeAt(i) ^ key.charCodeAt(i % key.length)
    encryptedText += String.fromCharCode(charCode)
  }

  return encryptedText
}

/**
 * @desc 解密
 * @param key {string} 密钥
 * @param encryptedText {string} 需要解密的数据
 * */
export const decryptTextWithToken = (key, encryptedText) => {
  let decryptedText = ''
  for (let i = 0; i < encryptedText.length; i++) {
    let charCode = encryptedText.charCodeAt(i) ^ key.charCodeAt(i % key.length)
    decryptedText += String.fromCharCode(charCode)
  }

  return decryptedText
}
